import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyBM2-qd6o_q7UExX5Qwi2TVQAPyA54e3Nk",
  authDomain: "binventory-10b6c.firebaseapp.com",
  projectId: "binventory-10b6c",
  storageBucket: "binventory-10b6c.firebasestorage.app",
  messagingSenderId: "1055078426960",
  appId: "1:1055078426960:web:ec1486575b2f6afe5be455",
  measurementId: "G-Q6DMJ1MKD4"
};

// Initialize Firebase with CORS settings
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);
const functions = getFunctions(app);

// Set the region for Cloud Functions
functions.region = 'us-central1';

export { db, auth, storage, functions };

export const PLAN_LIMITS = {
  free: {
    maxRooms: 2,
    maxBinsPerRoom: 5,
    maxStorage: 100 * 1024 * 1024, // 100MB in bytes
  },
  premium: {
    maxRooms: Infinity,
    maxBinsPerRoom: Infinity,
    maxStorage: 10 * 1024 * 1024 * 1024, // 10GB in bytes
  }
};

export const DEFAULT_USER_METRICS = {
  roomCount: 0,
  totalBins: 0,
  storageUsed: 0,
  plan: 'free',
  stripeCustomerId: null,
  subscriptionId: null,
  subscriptionStatus: null,
  trialEnd: null
}; 